import React from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";

export const VideoJS = ( props ) =>
{

	const videoRef = React.useRef( null );
	const playerRef = React.useRef( null );
	const { options, onReady } = props;

	React.useEffect( () =>
	{
		if ( !playerRef.current )
		{
			const videoElement = videoRef.current;
			if ( !videoElement ) return;

			const player = playerRef.current = videojs( videoElement, options, () =>
			{
				console.log( "player is ready" );

				onReady && onReady( player );
			} );

		}
		else
		{
			// const player = playerRef.current;
			// player.autoplay( options.autoplay );
			// player.src( options.sources );
			//
			// player.ready(function() {
			// 	// get
			// 	let howLoudIsIt = player.volume();
			// 	// set
			// 	player.volume(0.5); // Set volume to half
			// 	// player.requestPictureInPicture();
			//
			//
			// });

		}
	}, [ options ] );

	React.useEffect( () =>
	{
		return () =>
		{
			if ( playerRef.current )
			{
				playerRef.current.dispose();
				playerRef.current = null;
			}
		};
	}, [] );

	return (
		<div data-vjs-player>
			<video  style={{"objectFit" : "cover", "width" : "100%" , "height" : "100px"}}
			        ref={videoRef} id="video-player" className="video-js vjs-layout-x-small"/>
		</div>
	);
};

export default VideoJS;